export const questionnairDependencies = {
  dependencie_creation_error: 'Erreur lors de la création de la dépendence',
  dependencie_creation_success: 'La création de la dépendence a été effectué avec succès',
  questionnair_dependencie_sequencing: 'Séquencement',
  questionnair_dependencie_nextQuestion: 'Question suivante',
  cant_delete_text: 'Cette question ne peut pas être supprimée. Vérifiez ses dépendances.',
  condition: 'Condition',
  questionnaire_dependency_error: 'Erreur lors de l\'obtention des dépendances'
};
